import { css, keyframes } from '@emotion/core';

/**
 * Animation visual docs at https://www.figma.com/file/TIeFUqG2iMWWkfOlsvUHWr/00-%E2%80%93-Design-System?node-id=1894%3A2728
 */

export const BEZIER_CURVES = {
  FUNCTIONAL: 'cubic-bezier(.25, .25, .1, 1)',
  FLUID: 'cubic-bezier(.4, 0, 0, 1)',
};

export const ANIMATION_LENGTH = {
  _300MS: '.3s',
  _700MS: '.7s',
  _1000MS: '1s',
};

const fadeOut = keyframes({
  from: {
    opacity: 1,
  },
  to: {
    opacity: 0,
  },
});

const fadeIn = keyframes({
  from: {
    opacity: 0,
  },
  to: {
    opacity: 1,
  },
});

export const modalFadeOutCss = css({
  animation: `${fadeOut} ${ANIMATION_LENGTH._300MS} ${BEZIER_CURVES.FLUID} 0s 1 both`,
  display: 'none',
});

export const modalFadeInCss = css({
  animation: `${fadeIn} ${ANIMATION_LENGTH._1000MS} ${BEZIER_CURVES.FLUID} ${ANIMATION_LENGTH._300MS} 1 both`,
});
